import {
  useQuery,
  UseQueryResult,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "@tanstack/react-query";
import { PostAllTagsAttachedToMiners } from "../../api/api";
import { useState } from "react";

type GetTagsListProps = {
  open: boolean;
  authToken: string;
  tagName: string;
  serialNos: string[];
};

type Tag = {
  tag: string;
  // isDefaultTag: boolean;
  // occurrence: number;
};

type TagList = {
  status: string;
  msg: Tag[];
};

export const useListTagsAttachedToMiners = ({
  open,
  authToken,
  tagName,
  serialNos,
}: GetTagsListProps): UseInfiniteQueryResult<
  TagList,
  Error
> => {
  const [totalCount, setTotalCount] = useState(0);
  let limit = 25;

  return useInfiniteQuery({
    queryKey: [
      "TagsListAttachedToMiners",
      open,
      authToken,
      tagName,
      serialNos,
    ],
    initialPageParam: { skip: 0, limit },
    staleTime: 1000 * 60 * 5,
    queryFn: ({
      pageParam,
    }: {
      pageParam: { skip: number; limit: number };
    }) =>
      PostAllTagsAttachedToMiners({
        authToken,
        body: {
          tag: pageParam,
          serialNos: [...serialNos],
          filter: { tagName },
        },
      }).then((res) => {
        setTotalCount(res?.count);
        return res;
      }),
    enabled: !!authToken && !!open,
    getNextPageParam: (
      lastPage: TagList,
      allPages: TagList[]
    ) => {
      const totalFetched = allPages.flatMap(
        (page) => page.msg
      ).length;

      // Stop fetching if the total fetched rows reach or exceed the total count
      if (totalFetched >= totalCount) {
        return undefined;
      }

      // Return the skip value for the next page
      return { skip: allPages.length * limit, limit };
    },
  });
};
